import React from 'react';
import './GalleryBlock.scss';
import Heart from '../../Assets/home/heart.svg'

const GalleryBlock = (props) => {

  const block = props.nftBlocks.slice(0, props.postNum).map((el, index) => {
    return(
      <div key={index} className={!el.pack ? "gallery_block_wrapper" : "gallery_block_wrapper pack_wrapper"}>
      <div className={props.darkMode ? "gallery_block dark" : "gallery_block"}>
        <div className={!el.pack ? "gallery_block_img" : "pack"}>
        <div className="gallery_block_img_wrapper">
          <img src={el.img} alt="gallery block img" />
        </div>
        </div>
        <div className="gallery_block_info">
          <h6>{el.value}</h6>
          <a href="none">{el.author}</a>
          <div className="gallery_block_footer">
            <span>
              <img src={Heart} alt="heart" />
              1,2 k
            </span>
            <span className="count">{el.price}</span>
          </div>
        </div>
      </div>
    </div>
    )
  })

  return (
    <>
      {block}
    </>
  );
};

export default GalleryBlock;
